function toMoneyNumber(value) {
  const number = Number(value);
  return Number.isFinite(number) ? number : 0;
}

function toCents(value) {
  return Math.round((toMoneyNumber(value) + Number.EPSILON) * 100);
}

function multiplyMoney(quantity, unitPrice) {
  const count = Math.max(0, Number(quantity) || 0);
  return count * toCents(unitPrice) / 100;
}

function formatMoney(value, { minimumFractionDigits = 0 } = {}) {
  return (toCents(value) / 100).toLocaleString('zh-CN', {
    minimumFractionDigits,
    maximumFractionDigits: 2,
  });
}

export { formatMoney, multiplyMoney, toCents };
